module.exports = __webpack_public_path__ + "static/media/mock_ipl_bidding.2193459e.svg";